import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { RoutePaths } from 'constant';
import { BreadCrumbContainer } from './breadcrumbs.styles';

export const BreadCrumbs = () => {
  return (
    <Link to={RoutePaths.projects}>
      <BreadCrumbContainer>
        <FormattedMessage id="breadcrumbs.projects" />
      </BreadCrumbContainer>
    </Link>
  );
};

export const MemoedBreadCrumbs = memo(BreadCrumbs);
